import React from "react";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { TextInputLiveFeedback } from "./TextInputLiveFeedback";
import { ButtonNotice } from "../ButtonNotice/ButtonNotice";
import { Loader } from "../Loader/Loader";
import { useTranslation } from 'react-i18next';
import "./Checkout.css";
import { constants } from "../../Utils/constants";
const { PRIVACY_URL, TERMS_URL, ID } = constants.OPERATING_ENTITIES.NAYAX;

export const CoreForm = (props) => {
  const { formik, domState,mitigationAction,errMsg, operatingEntityId } = props;
  const { t } = useTranslation();
  const isNayaxEntity = operatingEntityId === ID;

  const handleExpirationChange = (event) => {
    let value = event.target.value;
    const key = event.key;
    if (key !== 'Backspace' && key !== 'Delete') {
      value = value.replace(/\D/g, '');
      value = value.replace('/', '');
    if (value.length >= 2) {
      value = value.slice(0, 2) + '/' + value.slice(2);
    }
    event.target.value = value;
  }
  };

  return (
    // data-cs-mask: card fields are native inputs, keep them out of Contentsquare recordings
    <div className="whole-form" data-cs-mask>
      <TextInputLiveFeedback
        label= {t('card_holder_name_label')}
        id="credit-card-card-holder"
        name="card_holder_name"
        type="text"
      />
      <TextInputLiveFeedback
        label= {t('card_number_label')}
        id="credit-card-card-number"
        name="card_number"
        type="text"
      />
      <div className="flex-form-control">
        <TextInputLiveFeedback
          label={t('expiration_date_label')}
          id="credit-card-card-expiration"
          name="expiry_date"
          type="text"
          className="sm-input"
          placeholder="MM/YYYY"
          onKeyUp={handleExpirationChange}
        />
        <TextInputLiveFeedback
          label={t('cvv_label')}
          id="credit-card-card-cvv"
          name="cvv"
          type="password"
          className="sm-input"
        />
      </div>
      <div className="flex-button-area">
        <button
          disabled={!formik.isValid || !formik.dirty || formik.isSubmitting === true}
          type="submit"
          className={(domState === "verification_failure") ? "accept-btn accept-btn-failed-bg" : "accept-btn accept-btn-bg"}
          id="submit-btn"
        >
          <div className="center-loader">
          {(domState === 'cc_check') &&  <Loader />}
          </div>
          {<ButtonNotice domState={domState} mitigationAction={mitigationAction}/>}
        </button>
      </div>
      {(domState === 'verification_success') && 
        <div>Please wait while we finalize your order</div> 
      }
      {(domState === 'verification_failure') && 
        <div className="psp-failure-resp" style={{color: '#d80027', paddingTop: "0.8rem"}}>{errMsg}</div>
      }
      <div className="footer-div">
      <p className="terms-align-bottom">
        {isNayaxEntity ? t('privacy_policy_text_nayax_llc') : t('privacy_policy_text')}{' '}
        {isNayaxEntity ? (
          <a className="nav-link" href={PRIVACY_URL} target="_blank" rel="noreferrer">
            {t('privacy_policy')}
          </a>
        ) : (
          <NavLink className="nav-link" to="/privacy-policy" target="_blank">
            {t('privacy_policy')}
          </NavLink>
        )}{' '}
        {t('terms_and_conditions_text')}{' '}
        {isNayaxEntity ? (
          <a className="nav-link" href={TERMS_URL} target="_blank" rel="noreferrer">
            {t('terms_and_conditions')}
          </a>
        ) : (
          <NavLink className="nav-link" to="/terms-conditions" target="_blank">
            {t('terms_and_conditions')}
          </NavLink>
        )}
      </p>
      {/* <p className="align-bottom">
        {t('business_growth_message')}
        <br />
        {isNayaxEntity ? t('team_message_nayax_llc') : t('team_message')}
      </p> */}
    </div>
    </div>
  );
};
